import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FORM_HISTORY_MODAL, TranslationsService } from '@wdx/shared/utils';
import { takeUntil } from 'rxjs/operators';
import { ModalManagementService } from '@wdx/clmi/ui';
import { BaseComponentClass } from '../../../classes/base-component.class';
import { AtomModalWrapperModule } from '../../atoms/atom-modal-wrapper/atom-modal-wrapper.module';
import { OrganismModalModule } from '../organism-modal/organism-modal.module';
import { WdxFormFrameworkModule } from '@wdx/shared/infrastructure/form-framework';

@Component({
    selector: 'organism-form-history-modal',
    templateUrl: './organism-form-history-modal.component.html',
    standalone: true,
    imports: [
        CommonModule,
        AtomModalWrapperModule,
        OrganismModalModule,
        WdxFormFrameworkModule,
    ],
})
export class OrganismFormHistoryModalComponent extends BaseComponentClass {
    @Input() modalId: string;

    public formId: string;
    public entityId: string;
    public title: string;

    constructor(
        modalManagementService: ModalManagementService,
        private translationsService: TranslationsService,
    ) {
        super();
        this.patchInjectedItems({ modalManagementService });

        this.modalManagementService.latestInstanceParams$
            .pipe(takeUntil(this.destroyed$))
            .subscribe((params) => {
                if (
                    params?.modalId === FORM_HISTORY_MODAL &&
                    params?.modalId === this.modalId
                ) {
                    const newFormId = params.modalParams?.formId;
                    const newEntityId = params.modalParams?.entityId;

                    if (
                        this.formId !== newFormId ||
                        this.entityId !== newEntityId
                    ) {
                        this.formId = newFormId;
                        this.entityId = newEntityId;
                        this.title = params.modalParams.title || 'History';
                    }
                }
            });
    }

    close() {
        this.modalManagementService.closeModalWithId(this.modalId);
    }

    getTitle(): string {
        return this.translationsService.translateTokenisedString(this.title);
    }
}
